@let mode = modeSg();
@let editing = configFeature.selectors.editingSession.asSignal();
@let agentId = editing?.agentId;
@let conversationId = editing?.conversationId;
@let isLoading =
  mode === 'agent'
    ? agentId
      ? configFeature.selectors.agentDefaultIsLoading(agentId).asSignal()
      : false
    : conversationId
      ? configFeature.selectors
          .conversationOverrideIsLoading(conversationId)
          .asSignal()
      : false;
@let draft =
  mode === 'agent'
    ? configFeature.selectors.editingAgentDraft.asSignal()
    : configFeature.selectors.editingConversationDraft.asSignal();
@let inherited = mode === 'conversation' && draft === undefined;

<div class="atn-assistant-configuration-form">
  @if (isLoading) {
    <div class="atn-assistant-configuration-form__loader">
      <atn-ds-loader />
    </div>
  } @else if (inherited) {
    <div class="atn-assistant-configuration-form__inherited-banner">
      <div class="atn-assistant-configuration-form__inherited-banner-text">
        <i class="atn-icon atn-info atn-blue"></i>
        <span>
          Inherits from
          <strong>Agent default</strong>
          .
        </span>
      </div>
      <atn-ds-button
        type="transparent"
        (click)="requestOverride()"
      >
        Override
      </atn-ds-button>
    </div>
  } @else {
    @let schema = schemaFeature.selectors.schema.asSignal();
    @let knowledgeBaseFiles =
      agentId
        ? configFeature.selectors
            .agentAvailableKnowledgeBaseFiles(agentId)
            .asSignal()
        : [];
    <section class="atn-assistant-configuration-form__section">
      <p class="atn-assistant-configuration-form__section-hint">
        Tell the agent how to use the resources below.
      </p>
      <atn-ds-text-area
        placeholder="e.g. Prefer recent records. Summarize before answering."
        [value]="draft?.instructions"
        (valueChange)="updateField('instructions', $event?.trim() || undefined)"
      />
    </section>

    <section class="atn-assistant-configuration-form__section">
      <p class="atn-assistant-configuration-form__section-hint">
        A DMS query whose selection returns the records and S3 file URIs to
        include as context. The result must contain both
        <code>records</code>
        and
        <code>files</code>
        .
      </p>
      <div class="atn-assistant-configuration-form__code-editor">
        <atn-ds-code
          syntax="dms-query"
          [json]="draft?.dmsResources"
          [schema]="schema"
          (jsonChange)="updateField('dmsResources', $any($event))"
        />
      </div>
    </section>

    <section class="atn-assistant-configuration-form__section">
      <p class="atn-assistant-configuration-form__section-hint">
        Attach knowledge-base files to every prompt for this agent.
      </p>
      <div class="atn-assistant-configuration-form__knowledge-base-files">
        @for (
          file of knowledgeBaseFiles;
          track file.knowledgeBaseId + ':' + file.s3Uri
        ) {
          <div class="atn-assistant-configuration-form__knowledge-base-file">
            <atn-ds-checkbox
              [selected]="
                mode === 'agent'
                  ? configFeature.selectors
                      .agentDraftFileIsSelected(file)
                      .asSignal()
                  : configFeature.selectors
                      .conversationDraftFileIsSelected(file)
                      .asSignal()
              "
              (selectedChange)="toggleKnowledgeBaseFile(file, $event)"
            />
            <div
              class="atn-assistant-configuration-form__knowledge-base-file-text"
              [title]="file.knowledgeBaseId"
            >
              <span
                class="atn-assistant-configuration-form__knowledge-base-file-path"
              >
                {{ Ents.core.agent.KnowledgeBase.File.getPath(file).split('/').at(-1) }}
              </span>
            </div>
          </div>
        } @empty {
          <div class="atn-assistant-configuration-form__empty-state">
            No knowledge-base files are available for this agent.
          </div>
        }
      </div>
    </section>
  }
</div>
